export default {
    'statistic-type': 'Tipo de estadística',
    'final-accounts': 'Cuentas finales',
    'custom-statements': 'Declaraciones personalizadas',
    'accounts-summary': 'Resumen de cuentas',
}